import React from "react";
// import Card from "./Card";
// import Pokeinfo from "./Pokeinfo";
import "../components/style.css";

const Inventory = () => {
  return (
    <>
    <div className="landingPageContainer">
        <div className="welcomeText">
            <h2>
               INVENTORY PAGE (not coded)
            </h2>
        </div>
        </div>
    </>
  );
};

export default Inventory;
